import { styled } from '@mui/material/styles';

export const Cell = styled('div', {
  label: 'DescriptionCell',
})(() => ({
  // affect on wrapper withItems for calculate column width, if change also change in src/components/Tables/grid/withResize/withResize.jsx
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 10,
  paddingRight: 10,

  width: '100%',
  textAlign: 'left',
  fontSize: 12,
  color: '#171A1C',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  unicodeBidi: 'plaintext',
}));
